import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { primary, secondary } from "../../../themes/theme";
import { SlideTransitionUp } from "../../SlideTransition";

// Props interface
interface DeleteItemDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  contentText: string;
  confirmText?: string;
  cancelText?: string;
}

// Component definition
const DeleteItemDialog: React.FC<DeleteItemDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  contentText,
  confirmText,
  cancelText,
}) => {
  const handleDeleteCancel = () => {
    onClose();
  };

  const handleDeleteConfirm = () => {
    onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDeleteCancel}
      TransitionComponent={SlideTransitionUp}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "20px",
          p: 2,
        },
      }}
      sx={{
        background: "#000E1C2d",
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            fontSize: "22px",
            fontFamily: "Ubuntu",
            color: primary[900],
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <Divider variant="fullWidth" />
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{
            fontFamily: "Ubuntu",
          }}
        >
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={handleDeleteCancel}
          sx={{
            fontFamily: "Ubuntu",
            textTransform: "capitalize",
            borderRadius: "15px",
            color: primary[800],
            background: secondary[300],
            border: "1px dashed transparent",
            "&:hover": {
              color: primary[900],
              background: "#fff",
              border: `1px dashed ${primary[800]}`,
            },
          }}
        >
          {cancelText ? cancelText : "Cancel"}
        </Button>
        <Button
          variant="text"
          onClick={handleDeleteConfirm}
          sx={{
            fontFamily: "Ubuntu",
            textTransform: "capitalize",
            borderRadius: "15px",
            color: "#FF3800",
            background: "#FF380010",
            border: "1px dashed transparent",
            "&:hover": {
              background: "#fff",
              border: "1px dashed #FF3800",
            },
          }}
          autoFocus
        >
          {confirmText ? confirmText : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteItemDialog;
